const createProgram = ({
  name,
  type,
  sourceUrl,
  mapUrl,
  overview,
  credential,
  format,
  length,
  tuition,
  admissions,
  focus,
  highlights,
  address,
}) => ({
  name,
  type,
  credential,
  format,
  length,
  tuition,
  admissions,
  summary: overview,
  badge: type,
  websiteUrl: sourceUrl,
  sourceUrl,
  specs: [
    ['Program type', type],
    ['Credential', credential],
    ['Class format', format],
    ['Program length', length],
    ['Tuition and fees', tuition],
    ['Admissions', admissions],
  ],
  paragraphs: [
    focus,
    'Review the official program page for current course availability, enrollment dates, program requirements, campus details, and any changes to published costs or credentials.',
  ],
  highlights,
  address,
  mapEmbedUrl: mapUrl,
});

export const programs = [
  createProgram({
    name: 'Lincoln Technical Institute (Union Campus)',
    type: 'Private technical career school',
    sourceUrl: 'https://www.lincolntech.edu/campus/union-nj/programs/hvac',
    mapUrl: 'https://www.google.com/maps?q=Lincoln+Technical+Institute+Union+NJ&output=embed',
    overview: 'Lincoln Technical Institute in Union provides intensive Air Conditioning, Refrigeration, and Heating Systems Technology training for students preparing for multi-faceted mechanical careers.',
    credential: 'Diploma / Career Training Certificate',
    format: 'Hands-on labs with classroom instruction and modern climate-control training units',
    length: '~12 months, approximately 50 credit or clock hours',
    tuition: 'Approximately $21,000–$30,500',
    admissions: 'Contact Lincoln Tech for current admissions requirements',
    focus: 'The curriculum covers electrical theory, wiring, diagnostic troubleshooting, EPA Section 608 preparation, and OSHA safety certification preparation. Students also benefit from employer networking and career placement services.',
    highlights: [
      'Modern climate-control training units',
      'Electrical theory, wiring, and diagnostics',
      'EPA Section 608 and OSHA certification preparation',
      'Employer networking and career placement services',
    ],
    address: 'Lincoln Technical Institute, Union, New Jersey',
  }),
  createProgram({
    name: 'Lincoln Technical Institute (Mahwah Campus)',
    type: 'Private technical career school',
    sourceUrl: 'https://www.lincolntech.edu/campus/mahwah-nj/programs/hvac',
    mapUrl: 'https://www.google.com/maps?q=Lincoln+Technical+Institute+Mahwah+NJ&output=embed',
    overview: 'Lincoln Technical Institute’s Mahwah campus offers comprehensive HVAC technology training that combines classroom instruction with extensive practical workshop experience.',
    credential: 'Diploma / Career Training Certificate',
    format: 'Interactive classroom instruction and practical workshop training',
    length: '~12 months',
    tuition: 'Approximately $30,535, plus books and supplies',
    admissions: 'Contact Lincoln Tech for current admissions requirements',
    focus: 'Students learn to install, maintain, and repair residential and commercial heating and cooling systems, read electrical schematics, and handle refrigerants safely. Career support helps graduates prepare for entry-level employment.',
    highlights: [
      'Residential and commercial heating and cooling systems',
      'Electrical schematics and refrigerant safety',
      'Practical workshop training',
      'Career support and job-market preparation',
    ],
    address: 'Lincoln Technical Institute, Mahwah, New Jersey',
  }),
  createProgram({
    name: 'Lincoln Technical Institute (Moorestown Campus)',
    type: 'Private technical career school',
    sourceUrl: 'https://www.lincolntech.edu/campus/moorestown-nj/programs/hvac',
    mapUrl: 'https://www.google.com/maps?q=Lincoln+Technical+Institute+Moorestown+NJ&output=embed',
    overview: 'Lincoln Technical Institute in Moorestown delivers specialized air conditioning, refrigeration, and heating systems training for students preparing for technician roles in southern New Jersey.',
    credential: 'Diploma / Career Training Certificate',
    format: 'Hands-on technical instruction with classroom and lab work',
    length: '~12 months',
    tuition: 'Approximately $30,535',
    admissions: 'Contact Lincoln Tech for current admissions requirements',
    focus: 'The curriculum includes compressor replacement, psychrometric chart plotting, electrical troubleshooting, and practical system service. Graduates prepare for essential industry certifications and entry-level service roles.',
    highlights: [
      'Air conditioning, refrigeration, and heating systems',
      'Compressor replacement and electrical troubleshooting',
      'Psychrometric chart instruction',
      'Southern New Jersey service-career preparation',
    ],
    address: 'Lincoln Technical Institute, Moorestown, New Jersey',
  }),
  createProgram({
    name: 'Universal Technical Institute (Bloomfield Campus)',
    type: 'Private technical career school',
    sourceUrl: 'https://www.uti.edu/campuses/new-jersey/bloomfield',
    mapUrl: 'https://www.google.com/maps?q=Universal+Technical+Institute+Bloomfield+NJ&output=embed',
    overview: 'UTI’s Bloomfield campus offers focused HVACR technician training that combines foundational theory with intensive practical laboratory work.',
    credential: 'Diploma / Industry Certificate',
    format: 'Classroom instruction and practical laboratory work',
    length: 'Less than 12 months, approximately 7–10 months',
    tuition: 'Varies by schedule and financial aid; typically $20,000–$30,000',
    admissions: 'Review current UTI Bloomfield admissions requirements',
    focus: 'Students learn installation fundamentals, electrical troubleshooting, and refrigeration diagnostics on industry-standard equipment. Career services and employer relationships support preparation for EPA Section 608 and NATE Core credentials.',
    highlights: [
      'Less-than-one-year HVACR training pathway',
      'Industry-standard equipment',
      'Electrical troubleshooting and refrigeration diagnostics',
      'EPA Section 608 and NATE Core preparation',
    ],
    address: 'Universal Technical Institute, Bloomfield, New Jersey',
  }),
  createProgram({
    name: 'Aviation Institute of Maintenance (Hasbrouck Heights Campus)',
    type: 'Private technical training institute',
    sourceUrl: 'https://aviationmaintenance.edu/campuses/hasbrouck-heights-nj/',
    mapUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3017.329882250299!2d-74.06792832415657!3d40.864634228257685!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c2f856ae473d11%3A0x43af1faf762beb24!2sAviation%20Institute%20of%20Maintenance!5e0!3m2!1sen!2sus!4v1790283454586!5m2!1sen!2sus',
    overview: 'Aviation Institute of Maintenance in Hasbrouck Heights offers structured HVAC training focused on practical skill development and workplace readiness.',
    credential: 'Certificate / Diploma',
    format: 'Structured classroom instruction and hands-on equipment practice',
    length: '12 months, or 48 weeks',
    tuition: 'Varies by enrollment path; typically $22,000–$27,000',
    admissions: 'Contact AIM for current admissions requirements',
    focus: 'Coursework spans electrical theory, refrigeration loops, heat pumps, and brazing techniques using real-world equipment. Students prepare for credentials such as the OSHA 30-Hour Safety card and EPA Universal refrigerant certification.',
    highlights: [
      'Structured 12-month HVAC program',
      'Electrical theory, heat pumps, and refrigeration loops',
      'Hands-on brazing practice',
      'OSHA 30-Hour and EPA Universal preparation',
    ],
    address: 'Aviation Institute of Maintenance, Hasbrouck Heights, New Jersey',
  }),
  createProgram({
    name: 'Hudson County Community College',
    type: 'Public community college',
    sourceUrl: 'https://www.hccc.edu/',
    mapUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3023.4211644153847!2d-74.0624145!3d40.73075729999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c257318abb852d%3A0x76d3e03e90c18814!2sHudson%20County%20Community%20College!5e0!3m2!1sen!2sus!4v1790283039605!5m2!1sen!2sus',
    overview: 'Hudson County Community College offers academic programs and workforce development certificates tailored to the employment needs of urban New Jersey.',
    credential: 'Workforce Development Certificate / Associate Degree',
    format: 'Public college instruction with workforce development support',
    length: '1–2 years',
    tuition: '$3,295',
    admissions: 'Review current HCCC admissions and workforce program requirements',
    focus: 'HCCC equips learners with practical technical competencies and critical thinking skills. Students may enter local trade careers or use stackable credits toward advanced degrees.',
    highlights: [
      'Urban New Jersey workforce focus',
      'Budget-friendly public county tuition',
      'Workforce development certificates',
      'Stackable academic and career pathways',
    ],
    address: 'Hudson County Community College, Jersey City, New Jersey',
  }),
  createProgram({
    name: 'The Training Center HVAC Technician Program',
    type: 'Private technical training program',
    sourceUrl: 'https://www.thetrainingcenter.com/tap',
    mapUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3052.949465834473!2d-74.56365819999999!3d40.0765393!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c168769bed8bcb%3A0xfd5b8b1612954ea7!2sThe%20Training%20Center!5e0!3m2!1sen!2sus!4v1790283186238!5m2!1sen!2sus',
    overview: 'The Training Center delivers a flexible HVAC career program through a state-of-the-art New Jersey lab, combining classroom lectures with hands-on practice for beginners.',
    credential: 'Professional Training Certificate',
    format: 'Classroom lectures and hands-on laboratory training',
    length: '11 months',
    tuition: 'Program-specific pricing available upon inquiry; flexible payment plans offered',
    admissions: 'Review current Training Center admissions requirements',
    focus: 'The curriculum covers heating, ventilation, air conditioning, refrigeration, and state licensing support. Students prepare for essential industry credentials, including EPA Universal Section 608 certification.',
    highlights: [
      'Flexible 11-month career program',
      'State-of-the-art New Jersey laboratory',
      'HVAC and refrigeration fundamentals',
      'State licensing support and EPA Universal certification',
    ],
    address: 'The Training Center, New Jersey',
  }),
  createProgram({
    name: 'Pennsylvania College of Technology Online HVAC/R Training',
    type: 'Online and technical career training',
    sourceUrl: 'https://www.penncotech.edu/programs/air-conditioning-refrigeration-heating/',
    mapUrl: 'https://www.google.com/maps?q=Pennsylvania+College+of+Technology+HVAC+R&output=embed',
    overview: 'Pennsylvania College of Technology offers online and technical training tracks for servicing, maintaining, and troubleshooting heating, ventilation, air conditioning, and refrigeration systems.',
    credential: 'Certificate / Associate in Applied Science (AAS) Degree',
    format: 'Online and technical training tracks',
    length: 'Flexible online and technical course pacing, typically 1–2 years',
    tuition: 'Per-credit public or private tuition rates vary by residency status',
    admissions: 'Review current program enrollment requirements',
    focus: 'The curriculum emphasizes problem-solving, electrical theory, and advanced mechanical diagnostics. Students gain access to industry-aligned resources and certification support for credentials such as EPA Section 608 and HVAC Excellence.',
    highlights: [
      'Online and technical HVAC/R pathways',
      'Electrical theory and mechanical diagnostics',
      'Residential and commercial service concepts',
      'Certificate and AAS degree options',
    ],
    address: 'Pennsylvania College of Technology, Online HVAC/R Training',
  }),
  createProgram({
    name: 'Sunset Technology Center',
    type: 'Technical and vocational training center',
    sourceUrl: 'https://sunsettechnologycenter.com/',
    mapUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3021.216666978506!2d-74.0222866!3d40.7792506!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c25822412fad65%3A0x76a37c77cdb22a5c!2sSunset%20Technology%20Center!5e0!3m2!1sen!2sus!4v1790283274622!5m2!1sen!2sus',
    overview: 'Located in Union City, Sunset Technology Center provides targeted technical instruction and vocational courses for adult learners in New Jersey and the greater New York metro area.',
    credential: 'Vocational Training Certificate',
    format: 'Localized vocational instruction for adult learners',
    length: 'Short-term vocational training length',
    tuition: 'Varies based on specific vocational track selection',
    admissions: 'Contact Sunset Technology Center for current enrollment requirements',
    focus: 'The program focuses on core competencies in building trades and mechanical service work. Students receive accessible, localized training designed to support regional workforce needs and entry-level technical employment.',
    highlights: [
      'Adult-focused technical instruction',
      'Union City location',
      'Building trades and mechanical service fundamentals',
      'Training aligned with regional workforce needs',
    ],
    address: 'Sunset Technology Center, Union City, New Jersey',
  }),
  createProgram({
    name: 'Raritan Valley Community College Environmental Control Technology',
    type: 'Public community college',
    sourceUrl: 'https://www.raritanval.edu/programs/career-enhancement/career-training/hvac-environmental-control-technology/',
    mapUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3028.926496626015!2d-74.69052562416873!3d40.60944534388783!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c3937dc5acab1f%3A0x15e7f0de30681faa!2sRaritan%20Valley%20Community%20College!5e0!3m2!1sen!2sus!4v1790283306136!5m2!1sen!2sus',
    overview: 'Raritan Valley Community College offers Environmental Control Technology pathways with a one-year residential certificate and a two-year full degree track covering residential and commercial systems.',
    credential: 'Career Certificate / Associate of Applied Science (AAS) Degree',
    format: 'Public college classroom instruction and practical laboratory work',
    length: '1-year certificate or 2-year full degree track',
    tuition: 'Affordable county resident community college tuition rates',
    admissions: 'Review current RVCC admissions and program requirements',
    focus: 'The curriculum blends theory, system design, and practical lab work. The program supports both focused residential training and broader residential and commercial HVAC education.',
    highlights: [
      'Residential one-year career certificate',
      'Two-year AAS degree pathway',
      'Theory, design, and practical lab work',
      'Residential and commercial system coverage',
    ],
    address: 'Raritan Valley Community College, Branchburg, New Jersey',
  }),
  createProgram({
    name: 'New Jersey Department of Labor Approved Training Programs',
    type: 'State-approved workforce training resource',
    sourceUrl: 'https://mycareer.nj.gov/training/29955',
    mapUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3032.753616943218!2d-74.42804439999999!3d40.5249366!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c3c794a787fa4f%3A0x98f095d2ee30260b!2sPiscataway%20Magnet%20School!5e0!3m2!1sen!2sus!4v1790282344543!5m2!1sen!2sus',
    overview: 'The New Jersey Career Navigator and Training Explorer portal connects residents with vetted, state-approved occupational skills programs, including HVAC training providers across the state.',
    credential: 'State-Approved Occupational Certificate',
    format: 'Directory of approved classroom, online, and workforce programs',
    length: 'Varies by approved provider, typically 3–12 months',
    tuition: 'Variable; eligible programs may use state workforce grants, WIOA funding, and public assistance',
    admissions: 'Review each provider’s eligibility and application requirements',
    focus: 'The portal helps residents identify programs aligned with state licensing guidelines and high-demand industry standards. Students may also find grants, public funding, and workforce development support.',
    highlights: [
      'State-approved training provider directory',
      'HVAC programs across New Jersey',
      'Potential grants and workforce funding',
      'Training aligned with high-demand occupations',
    ],
    address: 'New Jersey Career Navigator and Training Explorer',
  }),
  createProgram({
    name: 'Camden County College Heating, Ventilation, Air-Conditioning Program',
    type: 'Public community college career training',
    sourceUrl: 'https://www.camdencc.edu/program/heating-ventilation-air-conditioning/',
    mapUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3066.00353714211!2d-75.03720349999999!3d39.784476000000005!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c6d235b06d5151%3A0xf33e4f16571d3d78!2sCamden%20County%20College!5e0!3m2!1sen!2sus!4v1790283382705!5m2!1sen!2sus',
    overview: 'Camden County College offers intensive in-person HVAC training in Sicklerville, New Jersey, designed to prepare students for entry-level technician roles.',
    credential: 'Certificate of Achievement',
    format: 'In-person classroom and hands-on technical training',
    length: '9 months',
    tuition: 'Approximately $6,000 in tuition and fees',
    admissions: 'Review current Camden County College admissions requirements',
    focus: 'The curriculum covers operation theory, safety, leak detection, gas and oil heating systems, heat pumps, and refrigerant recovery. Students prepare for the EPA Section 608 Universal certification exam.',
    highlights: [
      'Nine-month in-person program',
      'Sicklerville, New Jersey location',
      'Gas, oil, heat pump, and refrigerant recovery training',
      'EPA Section 608 Universal exam preparation',
    ],
    address: 'Camden County College, Sicklerville, New Jersey',
  }),
  createProgram({
    name: 'Atlantic Cape Community College HVAC/R Technician Career Training',
    type: 'Online community college career training',
    sourceUrl: 'https://careertraining.atlanticcape.edu/training-programs/hvacr-technician/',
    mapUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3080.3479196120093!2d-74.6811865!3d39.4614681!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c0dca42d565b81%3A0xda75cf7e387ea16!2sAtlantic%20Cape%20Community%20College!5e0!3m2!1sen!2sus!4v1790282583581!5m2!1sen!2sus',
    overview: 'Atlantic Cape Community College offers online HVAC/R Technician career training with flexible pacing, materials support, and curriculum covering residential and commercial HVAC/R fundamentals.',
    credential: 'Career Training Certificate',
    format: 'Self-paced online training with hands-on lab components',
    length: '12 months, 330 hours',
    tuition: 'Approximately $3,199–$3,295',
    admissions: 'Review current online enrollment requirements',
    focus: 'Students study thermodynamics, automatic controls, electrical motors, and commercial refrigeration through simulated challenges. Exam preparation and voucher packages support NATE Ready to Work, HVAC Excellence, and EPA Section 608 credentials.',
    highlights: [
      'Online 12-month, 330-hour program',
      'Self-paced learning and flexible payment plans',
      'Commercial refrigeration simulation challenges',
      'Credential preparation and voucher packages',
    ],
    address: 'Atlantic Cape Community College, Online HVAC/R Training',
  }),
];

export const resources = [
  {
    title: 'New Jersey Department of Labor and Workforce Development',
    description: 'Explore New Jersey workforce training, licensing, employment, and funding resources.',
    url: 'https://www.nj.gov/labor/',
  },
  {
    title: 'EPA Section 608 Technician Certification',
    description: 'Review federal refrigerant handling requirements and approved certification programs.',
    url: 'https://www.epa.gov/section608',
  },
  {
    title: 'New Jersey Career Navigator',
    description: 'Find state-approved training programs and potential workforce funding opportunities.',
    url: 'https://mycareer.nj.gov/training/29955',
  },
  {
    title: 'U.S. Bureau of Labor Statistics',
    description: 'Research HVAC mechanic and installer duties, pay, education, and employment outlook.',
    url: 'https://www.bls.gov/ooh/installation-maintenance-and-repair/heating-air-conditioning-and-refrigeration-mechanics-and-installers.htm',
  },
];